import _ from 'lodash';

/**
 * @example metadata.title -> properties.metadata.properties.title
 */
export function pathToJsonSchemaPath(path: string) {
  return 'properties.' + path.replaceAll('.', '.properties.');
}

/**
 * @example a.b.c -> properties.a.properties.b.required
 * @example a.b -> properties.a.required
 * @example a -> required
 */
function pathToRequiredPath(path: string) {
  const pathSplit = path.split('.');
  const segmentPath = pathSplit.slice(0, -1);
  let jsonSchemaRequiredPath = 'required';

  if (segmentPath.length > 0) {
    jsonSchemaRequiredPath =
      segmentPath.map(segment => `properties.${segment}`).join('.') +
      '.required';
  }

  return jsonSchemaRequiredPath;
}

/**
 * Accepts object path, e.g.: metadata.title and assigns JSON schema validation object
 * to that path (transformed into JSON schema path)
 */
export function setInJsonSchema(jsonSchema: {}, path: string, value: unknown) {
  _.set(jsonSchema, pathToJsonSchemaPath(path), value);
}

export function addToRequiredJsonSchemaField(jsonSchema: {}, path: string) {
  const pathSplit = path.split('.');
  const fieldName = pathSplit.at(-1);

  const jsonSchemaRequiredPath = pathToRequiredPath(path);

  const existingRequiredArray = _.get(jsonSchema, jsonSchemaRequiredPath) ?? [];
  const newRequiredArray = _.uniq([...existingRequiredArray, fieldName]);
  _.set(jsonSchema, jsonSchemaRequiredPath, newRequiredArray);
}

export function setConditionInJsonSchema(
  jsonSchema: {},
  path: string,
  condition: {}
) {
  _.set(jsonSchema, path, [...(_.get(jsonSchema, path) ?? []), condition]);
}

/**
 * AJV treats the JsonSchema branches in If/Else conditions as indepdenent sub-schemas,
 * so we need to repeat type: object for every nesting level - otherwise we'll get warning logs.
 */
export function createConditionalBranch(
  obj: {},
  path: string,
  val: {},
  isRequired?: boolean
) {
  const pathSplit = path.split('.');
  const rootFieldName = pathSplit.shift();

  return {
    ...(isRequired ? {} : { required: [rootFieldName] }),
    ..._.setWith(obj, pathToJsonSchemaPath(path), val, (_, key) => {
      if (key === 'properties') {
        return {};
      }

      const fieldName = pathSplit.shift();
      return {
        type: 'object',
        required: [fieldName]
      };
    })
  };
}
